import React, { useState } from 'react';
import { 
  Dropdown, 
  DropdownToggle, 
  DropdownMenu, 
  DropdownItem 
} from 'reactstrap';
import { 
  ChevronDown, 
  Copy, 
  UserPlus, 
  FolderInput, 
  Share2, 
  Trash2,
  Smartphone
} from 'lucide-react';

interface LeadOptionsMenuProps {
  leadId: string;
  onCopyToList: () => void;
  onAssignLead: () => void;
  onMoveToList: () => void;
  onShare: () => void;
  onSendToMobile?: () => void;
  onDelete?: () => void;
  isDeleteAllowed?: boolean;
}

const LeadOptionsMenu: React.FC<LeadOptionsMenuProps> = ({
  leadId,
  onCopyToList,
  onAssignLead,
  onMoveToList,
  onShare,
  onSendToMobile = () => {},
  onDelete,
  isDeleteAllowed = true
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prev => !prev);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle 
        className="border-0 flex items-center ml-auto"
        style={{
          fontSize: "13px",
          background: "none",
          fontWeight: "700",
          color: "#00000099",
        }}
      >
        Options
        <ChevronDown className="ml-1" size={18} />
      </DropdownToggle>

      <DropdownMenu className="lead_options_dropdown">
        <DropdownItem
          tag="div"
          className="text-base font-medium"
        >
          Lead options
        </DropdownItem>

        <DropdownItem
          onClick={onCopyToList}
          className="flex items-center"
        >
          <Copy size={18} className="mr-3" style={{ marginRight: "12px" }} />
          Copy to list
        </DropdownItem>

        <DropdownItem
          onClick={onAssignLead}
          className="flex items-center"
        >
          <UserPlus size={18} className="mr-3" style={{ marginRight: "12px" }} />
          Assign lead
        </DropdownItem>

        <DropdownItem
          onClick={onMoveToList}
          className="flex items-center"
        >
          <FolderInput size={18} className="mr-3" style={{ marginRight: "12px" }} />
          Move to list
        </DropdownItem>

        <DropdownItem
          onClick={onShare}
          className="flex items-center"
        >
          <Share2 size={18} className="mr-3" style={{ marginRight: "12px" }} />
          Quick share
        </DropdownItem>

        <DropdownItem
          onClick={onSendToMobile}
          className="flex items-center"
        >
          <Smartphone size={18} className="mr-3" style={{ marginRight: "12px" }} />
          Send to mobile
        </DropdownItem>

        {isDeleteAllowed && onDelete && (
          <DropdownItem
            onClick={onDelete}
            className="flex items-center text-red-600"
          >
            <Trash2 size={18} className="mr-3 text-red-600" />
            Delete
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LeadOptionsMenu;